import React from 'react';
const LoginSVG = ({ color = 'black', className }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Group 1437252863">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.23047 4.0339C3.23047 2.65024 4.36698 1.52856 5.76894 1.52856H9.46125C9.84357 1.52856 10.1535 1.83447 10.1535 2.21184C10.1535 2.5892 9.84357 2.89511 9.46125 2.89511H5.76894C5.13168 2.89511 4.61509 3.40496 4.61509 4.0339V4.94492C4.61509 5.32228 4.30513 5.62819 3.92278 5.62819C3.54043 5.62819 3.23047 5.32228 3.23047 4.94492V4.0339ZM3.92278 13.372C4.30513 13.372 4.61509 13.6779 4.61509 14.0552V14.9662C4.61509 15.5951 5.13168 16.105 5.76894 16.105H9.46125C9.84357 16.105 10.1535 16.411 10.1535 16.7883C10.1535 17.1657 9.84357 17.4716 9.46125 17.4716H5.76894C4.36698 17.4716 3.23047 16.3499 3.23047 14.9662V14.0552C3.23047 13.6779 3.54043 13.372 3.92278 13.372Z"
          fill={color}
        />
        <path
          id="Vector_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1538 3.00757C10.1538 2.21442 10.9548 1.6642 11.7085 1.93966L16.3239 3.62675C16.7765 3.7922 17.0769 4.21826 17.0769 4.69464V14.3054C17.0769 14.7818 16.7765 15.2078 16.3239 15.3732L11.7085 17.0604C10.9548 17.3359 10.1538 16.7856 10.1538 15.9924V3.00757ZM12.1894 0.658185C10.5314 0.0521603 8.76929 1.26264 8.76929 3.00757V15.9924C8.76929 17.7374 10.5314 18.9479 12.1894 18.3418L16.8048 16.6547C17.8006 16.2907 18.4616 15.3534 18.4616 14.3054V4.69464C18.4616 3.64658 17.8006 2.70928 16.8048 2.34527L12.1894 0.658185Z"
          fill={color}
        />
        <path
          id="Vector_3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.35651 7.195C4.62687 6.92816 5.06522 6.92816 5.33558 7.195L7.18174 9.01708C7.4521 9.28393 7.4521 9.71647 7.18174 9.98332L5.33558 11.8054C5.06522 12.0722 4.62687 12.0722 4.35651 11.8054C4.08614 11.5386 4.08614 11.106 4.35651 10.8391L5.02082 10.1835H1.15373C0.771386 10.1835 0.461426 9.87757 0.461426 9.5002C0.461426 9.12283 0.771386 8.81692 1.15373 8.81692H5.02082L4.35651 8.16127C4.08614 7.89442 4.08614 7.46184 4.35651 7.195Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default LoginSVG;
